import { render, staticRenderFns } from "./FormSingleValueYesNoComment.vue?vue&type=template&id=64edf230&"
import script from "./FormSingleValueYesNoComment.vue?vue&type=script&lang=js&"
export * from "./FormSingleValueYesNoComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports